import { useQuery } from "@tanstack/react-query";
import { getProjectedRecurringSchedules } from "../../fetchers/cmmsRecurringSchedule";

/*
 * The orders the calendar schedules are still to raise from `from` up to `to`, for the week and
 * month overviews. Asked for only while enabled. The view decides when that is.
 *
 * Keyed under cmmsRecurringSchedules, so whatever refreshes the schedules refreshes this as well.
 * useCmmsNotifications refreshes it too, when the sweep raises an order it had projected.
 * A single retry: a view waits for this before it draws, and the default three retries would hold
 * it behind a skeleton for seconds before a failure could show.
 */
export const useProjectedOccurrences = (companyKey, from, to, enabled) => {
  const fromIso = from.toISOString();
  const toIso = to.toISOString();
  return useQuery(
    ["cmmsRecurringSchedules", companyKey, { view: "projected", from: fromIso, to: toIso }],
    () => getProjectedRecurringSchedules(companyKey, fromIso, toIso),
    { enabled, staleTime: 30000, retry: 1 },
  );
};
